/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "ce95238b78842418993ef0c207e11696c7b7632f";
